import {Component, inject} from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef
} from "@angular/material/snack-bar";
import {MatButton} from "@angular/material/button";
import {SnackbarParams} from "../../../../core/types/snackbar-params.types";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-snackbar-custom',
  imports: [
    MatSnackBarLabel,
    MatSnackBarActions,
    MatButton,
    MatSnackBarAction,
    MatIcon
  ],
  templateUrl: './snackbar-custom.component.html',
  styleUrl: './snackbar-custom.component.scss'
})
export class SnackbarCustomComponent {
  public snackBarRef = inject(MatSnackBarRef);
  public data: SnackbarParams = inject(MAT_SNACK_BAR_DATA);
}
